import { render, staticRenderFns } from "./OsUpdate.vue?vue&type=template&id=3d5e7747&scoped=true"
import script from "./OsUpdate.vue?vue&type=script&lang=js"
export * from "./OsUpdate.vue?vue&type=script&lang=js"
import style0 from "./OsUpdate.vue?vue&type=style&index=0&id=3d5e7747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5e7747",
  null
  
)

export default component.exports